import React from 'react';

import { CustomizedTooltip } from 'components/common/CustomizedTooltip/CustomizedTooltip';

import classes from './NarrativeCell.module.scss';

interface Props {
    narrative?: string | null;
}

export const NarrativeCell = ({ narrative }: Props) => {
    return (
        <div className={classes.narrativeCell}>
            <CustomizedTooltip
                contentStyles={{ maxWidth: 800 }}
                tooltipContent={narrative}
                triggerElement={<div className={classes.max}>{narrative}</div>}
            />
        </div>
    );
};
